<template lang="html">
  <div>
    <div class="Vlt-card">
      <div class="Vlt-grid">
        <div class="Vlt-col Vlt-col--1of4">
          <localization style="display: inline-block" :langStart="'EN'" @language="languageChange"
            @baselang="baseLang" />
          <vlt-button secondary app class="button1" :label="disp('Links')" @click="links = true" />
        </div>
        <div class="Vlt-col Vlt-col--1of4">
          <vlt-button :key="buttonkey" secondary :label="disp('Delete') + ' ' + disp('Customer')"
            @click="doDelete(currentService)" />
        </div>
      </div>
      <div class="Vlt-grid">
        <div class="Vlt-col Vlt-col--1of4">
          <div class="Vlt-card" style="height: 130px;">
            <div class="Vlt-card__header">
              <h4>{{ disp('Customers') }}</h4>
            </div>
            <div class="Vlt-card__content">
              <vlt-button class="Vlt-btn--quaternary button2" :label="disp('Add Customer')" @click="addCust()" />
            </div>
          </div>
          <div class="Vlt-card Vlt-card--scrollable" style="height: 200px;">
            <div class="Vlt-card__header">
              <h4>{{ disp('pending') }}</h4>
            </div>
            <div class="Vlt-card__content">
              <vlt-button :key="currentService.sid + bkey"
                :icon="(currentService.sid == service.sid) ? 'check-circle' : ''" class="Vlt-btn--quaternary button2"
                v-for="(service) in pending" v-bind:key="service.sid"
                :label="disp(service.type) + ' ' + disp('for') + ' ' + service.name" @click="doService(service.sid)" />
            </div>
          </div>
          <div class="Vlt-card Vlt-card--scrollable" style="height: 300px;">
            <div class="Vlt-card__header">
              <h4>{{ disp('rescheduled') }}</h4>
            </div>
            <vlt-button :key="currentService.sid + bkey"
              :icon="(currentService.sid == service.sid) ? 'check-circle' : ''" class="Vlt-btn--primary button2"
              v-for="(service) in rescheduled" v-bind:key="service.sid"
              :label="disp(service.type) + ' ' + disp('for') + ' ' + service.name" @click="doService(service.sid)" />
          </div>
          <div class="Vlt-card Vlt-card--scrollable" style="height: 200px;">
            <div class="Vlt-card__header">
              <h4>{{ disp('completed') }}</h4>
            </div>
            <vlt-button :key="currentService.sid + bkey"
              :icon="(currentService.sid == service.sid) ? 'check-circle' : ''" class="Vlt-btn--tertiary button2"
              v-for="(service) in completed" v-bind:key="service.sid"
              :label="disp(service.type) + ' ' + disp('for') + ' ' + service.name" @click="doService(service.sid)" />
          </div>
          <vlt-button secondary app class="button1" :label="disp('Reset') + ' ' + disp('demo')"
            @click="startup(true)" />
        </div>
        <div v-if="currentService" class="Vlt-col Vlt-col--A-1of4">
          <vlt-field :label="disp('ID')">
            <vlt-input v-model="currentService.id" :val="currentService.id" :disabled="true" />
          </vlt-field>
          <vlt-field :label="disp('Name')">
            <vlt-input v-model="currentService.name" :val="currentService.name" @input="change" />
          </vlt-field>
          <vlt-field :label="disp('Address')">
            <vlt-input v-model="currentService.address" :val="currentService.address" @input="change" />
          </vlt-field>
          <vlt-field :label="disp('Area')">
            <vlt-input v-model="currentService.area" :val="currentService.area" @input="change" />
          </vlt-field>
          <vlt-field :label="disp('Phone')">
            <vue-phone-number-input :key="phonekey" style="paddingTop:4px" color="#131415" :no-validator-state="false"
              :default-country-code="region" v-model="aphone" @update="onUpdate" />
            <vlt-input v-if="false" v-model="currentService.phone" :val="currentService.phone" @input="change" />
          </vlt-field>
          <vlt-field :label="disp('Notes')">
            <vlt-input textarea :rows="3" v-model="currentService.notes" :val="currentService.notes" @input="change" />
          </vlt-field>
          <vlt-field class="Vlt-left" :label="disp('Service')">
            <div class="Vlt-native-dropdown">
              <select v-model="currentService.type" @change="change">
                <option :value="'Pickup'">{{ disp('Pickup') }}</option>
                <option :value="'Delivery'">{{ disp('Delivery') }}</option>
              </select>
            </div>
          </vlt-field>
          <vlt-field class="Vlt-left" :label="disp('Status')">
            <div class="Vlt-native-dropdown">
              <select v-model="currentService.newstatus" @change="change">
                <option :value="'pending'">{{ disp('Pending') }}</option>
                <option :value="'completed'">{{ disp('Completed') }}</option>
                <option :value="'rescheduled'">{{ disp('rescheduled') }}</option>
              </select>
            </div>
          </vlt-field>
          <hr class="hr--short Vlt-gradient--blue-to-pink" />
          <vlt-button :key="buttonkey" :disabled="!currentService.changed" class="Vlt-btn--quaternary button2"
            :label="disp('Update')" @click="doSave(currentService)" />
          <div class="Vlt-col Vlt-col--3of4">
            <GmapMap v-if="mapok" :center="{ lat: location.lat, lng: location.lng }" :zoom="13" map-type-id="terrain"
              style="width: 150%; height: 300px">
              <GmapMarker v-if="true" :position="{ lat: location.lat, lng: location.lng }" :clickable="true"
                :draggable="true" @click="center = m.position" />
            </GmapMap>
          </div>
        </div>
        <div v-if="currentService" class="Vlt-col Vlt-col--A-2of4 ">
          <div class="Vlt-card Vlt-card--scrollable" style="height: 844px;">
            <div class="Vlt-card__header">
              <div class="Vlt-grid">
                <div class="Vlt-col Vlt-col--1of3">
                  <h4>
                    {{ disp(currentService.type) + ' ' + disp('at') }}<br>{{ currentService.address }}<br>{{
            currentService.area }}
                  </h4>
                  <vlt-button :key="aKey2 + 5" :disabled="!currentService.conversation" secondary app class="button1"
                    :label="disp('Browse Conversation')" @click="getConversation(currentService.conversation, null)" />
                </div>
                <div v-if="currentService" class="Vlt-col Vlt-col--1of3">
                  <vue-speedometer :key="speedkey" :forceRender="refresh" id="s1" :height="150" :width="200"
                    :minValue="-1" :maxValue="1" :value="parseFloat(currentService.avgSentiment.toFixed(2))"
                    :currentValueText="disp('Customer') + ' ' + disp('Sentiment') + ': ${value}'" />
                </div>
                <div v-if="currentService" class="Vlt-col Vlt-col--1of3">
                  <vue-speedometer :key="speedkey + 1" :forceRender="refresh" id="s1" :height="150" :width="200"
                    :minValue="-1" :maxValue="1" :value="parseFloat(currentService.avgSentimentCourier.toFixed(2))"
                    :currentValueText="disp('Courier') + ' ' + disp('Sentiment') + ': ${value}'" />
                </div>
              </div>
            </div>
            <div class="Vlt-card__content">
              <div class="Vlt-table Vlt-table--data Vlt-table--cols">
                <table>
                  <thead>
                    <tr>
                      <th width="120">{{ disp('Time') }}</th>
                      <th>{{ disp('Event') }}</th>
                      <th width="280">{{ disp('Actions') }}</th>
                      <th width="30"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="action in actions" v-bind:key="action.actionId">
                      <td>{{ action.timestamp }}</td>
                      <td v-if="action.type == 'note'" :style="'color:' + action.color + ';font-size:16px'">
                        <b>"{{ action.transcript }}"</b><br>
                      </td>
                      <td :key="aKey3 + action.id" v-else-if="action.type == 'image'"
                        :style="'color:' + action.color + ';font-size:16px'">
                        {{ disp('Image') }} {{ disp(action.verb) }}:<br>
                        <img :id="'img_' + action.actionId" :ref="'img_' + action.actionId" :src="action.image"
                          @click="startModal2(action)" alt="logo" style="height:200px" />
                      </td>
                      <td v-else-if="action.type == 'comment'" :style="'color:' + action.color + ';font-size:16px'">
                        {{ action.comment }}
                      </td>
                      <td v-else-if="action.type == 'page'" :style="'color:' + action.color + ';font-size:16px'">
                        {{ disp('Paged by Customer') }}
                      </td>
                      <td v-else-if="action.type == 'call'" :style="'color:' + action.color + ';font-size:16px'">
                        {{ disp(action.verb) }} {{ disp('Customer') }}
                      </td>
                      <td v-else-if="action.type == 'link'" :style="'color:' + action.color + ';font-size:16px'">
                        {{ disp(action.from) }} {{ disp('Sent') }} {{ disp(action.to) }} {{ disp('link') }}
                      </td>
                      <td v-else-if="action.type == 'statechange'" :style="'color:red;font-size:16px'">
                        {{ disp('Interaction with customer set to') }}: {{ disp(action.verb) }}
                      </td>
                      <td v-else-if="action.type == 'schedule'" :style="'color:red;font-size:16px'">
                        {{ disp('Sent') + ' ' + disp(action.verb) + ' ' + disp('Verification to Customer for ') +
            action.time }}
                      </td>
                      <td v-else-if="action.type == 'confirm'" :style="'color:green;font-size:16px'">
                        {{ disp('Customer Confirmed Schedule') }}
                      </td>
                      <td v-else>
                        {{ disp('Other') }}: {{ action.actionId }}
                      </td>
                      <td :key="aKey2 + action.id" v-if="action.type == 'note'"
                        :style="'color:' + action.color + ';font-size:16px'">
                        <div v-if="!action.sent">
                          <vlt-button v-if="!action.sent" primary :label="disp('Send as Text')"
                            @click="doAction(action, 'text')" />
                          <vlt-button v-if="!action.sent" primary :label="disp('Send as Audio')"
                            @click="doAction(action, 'audio')" />
                          <vlt-button primary v-if="!action.sent" icon="play-3-full" @click="playAudio(action)" />
                        </div>
                        <div class="Vlt-grid" v-if="action.sent">
                          <div class="Vlt-col Vlt-col--A-2of4">
                            <vlt-icon v-if="false" icon="check-circle-negative" color="green" />
                            <b>{{ disp(action.verb) }} {{ disp(action.sent) }}</b>
                          </div>
                          <div v-if="action.sent == 'Audio'" class="Vlt-col Vlt-col--A-2of4">
                            <vlt-button quaternary icon="play-3-full" style="float: right;" :label="disp('Listen')"
                              @click="playAudio(action)" />
                          </div>
                        </div>
                      </td>
                      <td
                        v-else-if="(action.type == 'call') && (transcripts[action.actionId] && (transcripts[action.actionId].length > 0))"
                        :key="transkey" :style="'color:' + action.color + ';font-size:16px'">
                        <vlt-button primary :label="disp('Transcription')" @click="showTranscript(action)" />
                      </td>
                      <td v-else-if="action.type == 'schedule' && action.notes" :style="'color:red;font-size:16px'">
                        {{ disp('Notes') + ': ' + action.notes }}
                      </td>
                      <td v-else>
                      </td>
                      <td v-if="action.icon" :key="iconChange">
                        <vlt-icon :icon="action.icon" :color="action.iconcolor" class="Vlt-icon--small" />
                      </td>
                      <td v-else> </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vlt-modal class="Vlt-modal Vlt-modal--large" :okText="disp('Cancel')" v-if="modalImage" :canCancel="false"
      :visible="modalImage" @close="stopModal2" @confirm="stopModal2" :message="disp('Show Image')"
      :title="disp('Upload and send image')">
      <div class="Vlt-modal__content">
        <div class="Vlt-card">
          <img :src="bigPic" alt="logo" />
        </div>
      </div>
    </vlt-modal>
    <vlt-modal class="Vlt-modal Vlt-modal--large" :okText="disp('Done')" v-if="links" :canCancel="false"
      :visible="links" @close="links = false" @confirm="links = false" :message="disp('Show Links')"
      :title="disp('Show Links')">
      <div class="Vlt-modal__content">
        <div class="Vlt-card">
          <div class="Vlt-grid">
            <div class="Vlt-col Vlt-col--2of4">
              <vlt-button secondary app class="button1"
                :label="disp('Send') + ' ' + disp('Customer') + ' ' + disp('link')" @click="sendLink('customer')" />
              <br>or Scan:<br>
              <qrcode :value="'https://vids.vonage.com/vcourier/#/customer/' + demoId + '?cust=' + currentService.sid"
                :options="{ width: 150 }"></qrcode>
              <br>or:<br>
              <vlt-button secondary app class="button1" :label="disp('Open') + ' ' + disp('in') + ' ' + disp('New Tab')"
                @click="openTab('customer')" />
            </div>
            <div class="Vlt-col Vlt-col--2of4">
              <vlt-button secondary app class="button1"
                :label="disp('Send') + ' ' + disp('Courier') + ' ' + disp('link')" @click="sendLink('courier')" />
              <br>or Scan:<br>
              <qrcode :value="'https://vids.vonage.com/vcourier/#/courier/' + demoId" :options="{ width: 150 }">
              </qrcode>
              <br>or:<br>
              <vlt-button secondary app class="button1" :label="disp('Open') + ' ' + disp('in') + ' ' + disp('New Tab')"
                @click="openTab('courier')" />
            </div>
          </div>
        </div>
      </div>
    </vlt-modal>
    <vlt-modal class="Vlt-modal Vlt-modal--large" :okText="disp(okText)" v-if="inCall" :canCancel="false"
      :visible="inCall" @close="hangup" @confirm="hangup" :title="disp('Transcription')">
      <div class="Vlt-modal__content">
        <div class="Vlt-card Vlt-article window__messages__container" style="height: 700px;"
          id="window__messages__container">
          <div class="Vlt-table Vlt-table--data Vlt-table--cols" data-density="short">
            <table>
              <thead>
                <tr>
                  <th width="100">
                    <p><b>{{ disp('Time') }}</b></p>
                  </th>
                  <th>
                    <p class="Vlt-left" :style="'color:blue;float:left;margin-bottom:2'"><b>{{ disp('Courier') }}</b>
                    </p>
                    <p class="Vlt-right" :style="'color:green;float:right;'"><b>{{ disp('Customer') }}</b></p>
                  </th>
                  <th width="30"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="message in curTrans" :key='message.id'>
                  <td>{{ message.timestamp }}</td>
                  <td v-if="message.usertype == 'courier'" class="Vlt-left" :style="'color:blue;font-size:16px'">
                    {{ message.transcript }}</td>
                  <td v-else class="Vlt-right" :style="'color:green;font-size:16px; backgroundColor:WhiteSmoke'">
                    {{ message.transcript }}</td>
                  <td :style="(message.usertype != 'courier' ? 'backgroundColor:WhiteSmoke' : '')">
                    <vlt-icon :icon="message.icon" :color="message.iconcolor" class="Vlt-icon--small" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </vlt-modal>
    <vlt-modal class="Vlt-modal--large" message="Loading Conversation..." title="Conversation Event Browser"
      :canCancel="false" :visible="showThisConvo" @close="showThisConvo = false" @confirm="showThisConvo = false">
      <conversations v-if="events.length" :convos="events"></conversations>
    </vlt-modal>
    <vlt-modal v-if="adding" class="Vlt-modal--large" :okText="disp('Cancel')" :message="disp('Add New Customer')"
      :title="disp('Conversation Event Browser')" :canCancel="false" :visible="adding" @close="adding = false"
      @confirm="adding = false">
      <div class="Vlt-col Vlt-col--A-4of4">
        <vlt-field :label="disp('Name')">
          <vlt-input v-model="newcust.name" :val="newcust.name" />
        </vlt-field>
        <vlt-field :label="disp('Address')">
          <vlt-input v-model="newcust.address" :val="newcust.address" />
        </vlt-field>
        <vlt-field :label="disp('Area')">
          <vlt-input v-model="newcust.area" :val="newcust.area" />
        </vlt-field>
        <vlt-field :label="disp('Phone')">
          <vue-phone-number-input style="paddingTop:4px" color="#131415" :no-validator-state="false"
            :default-country-code="region" v-model="aphone2" @update="onUpdate2" />
        </vlt-field>
        <vlt-field :label="disp('Notes')">
          <vlt-input textarea :rows="3" v-model="newcust.notes" :val="newcust.notes" />
        </vlt-field>
        <vlt-field class="Vlt-left" :label="disp('Service Type')">
          <div class="Vlt-native-dropdown">
            <select v-model="newcust.type">
              <option :value="'Pickup'">{{ disp('Pickup') }}</option>
              <option :value="'Delivery'">{{ disp('Delivery') }}</option>
            </select>
          </div>
        </vlt-field>
        <vlt-field class="Vlt-left" :label="disp('Status')">
          <div class="Vlt-native-dropdown">
            <select v-model="newcust.newstatus">
              <option :value="'pending'">{{ disp('Pending') }}</option>
              <option :value="'completed'">{{ disp('Completed') }}</option>
              <option :value="'rescheduled'">{{ disp('Rescheduled') }}</option>
            </select>
          </div>
        </vlt-field>
        <hr class="hr--short Vlt-gradient--blue-to-pink" />
        <vlt-button class="Vlt-btn--quaternary button2" :label="disp('Save')" @click="doSave(newcust)" />
      </div>
    </vlt-modal>
  </div>
</template>

<script>
import { $HTTP } from "@/services/nidsInternal.js";
import { $HTTPDEMO, requestHandler } from "@/services/nidsService.js";
import {
  VltIcon,
  VltButton,
  VltCard,
  VltTab,
  VltGrid,
  VltCol,
  VltField,
  VltInput,
  VltCallout,
  VltModal,
} from "@vonagevolta/vue";
import LineChart from "./lineChart.js";
import { $BASE, $NODEBASE } from "@/base";
//import Pusher from "pusher-js";
import NexmoClient from "nexmo-client";
import DirectionsRenderer from "./directionsRenderer";
import conversations from "./conversations";
import localization from "@/demos/courier/localization";
import { scrollToBottom } from "@/components/chatter/src/helpers/scroll.js";
import axios from "axios";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import { uuid } from "vue-uuid";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { loadGmapApi, gmapApi } from "vue2-google-maps";
import VueSpeedometer from "vue-speedometer";

export default {
  name: "dispatcher",
  components: {
    "vlt-icon": VltIcon,
    "vlt-button": VltButton,
    "vlt-field": VltField,
    "vlt-input": VltInput,
    "vlt-callout": VltCallout,
    "vlt-modal": VltModal,
    LineChart,
    DirectionsRenderer,
    conversations: conversations,
    localization: localization,
    qrcode: VueQrcode,
    VueSpeedometer,
  },
  props: {
    id: {
      type: String,
      required: false,
    },
    nexmo: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      mapKey: "AIzaSyB8Lfw6x5Q-l9RBjIBgIwduqQ7a1GZLir4",
      flavor: "dispatcher",
      myClientApp: null,
      application: null,
      capplication: null,
      isReady: false,
      currentCall: null,
      currentService: null,
      transcripts: [],
      transcription: [],
      buttonkey: 1,
      curTrans: [],
      language: null,
      lang: null,
      baselang: null,
      aphone: "",
      aphone2: "",
      region: "",
      jwt: null,
      inCall: false,
      okText: "Hang Up",
      location: null,
      mapok: false,
      camera: false,
      aKey: 1,
      aKey2: 1,
      aKey3: 1,
      transkey: 1,
      phonekey: 1,
      bkey: 1,
      speedkey: 1,
      refresh: true,
      iconChange: 1,
      changed: false,
      active: false,
      links: false,
      newcust: {},
      adding: false,
      ringing: "@/assets/ringing.mp3",
      ringer: null,
      dest: null,
      sentiment: [],
      actions: [],
      recAction: null,
      processing: false,
      paged: false,
      events: [],
      demoId: "",
      nodeurl: "",
      sysevent: "",
      newmessage: "",
      testimage: null,
      showThisConvo: false,
      vidWin: null,
      video: false,
      NODEDEMO: {},
      //            pusher: {},
      //            channel: {},
      userId: null,
      inAgent: false,
      modal: false,
      modalImage: false,
      uploadFieldName: "photos",
      tab: 1,
      datacollection: {},
      chartOptions: {
        scales: {
          yAxes: [
            {
              ticks: {
                min: -1.1,
                max: 1.1,
                stepSize: 0.2,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                autoSkip: true,
                maxTicksLimit: 12,
              },
            },
          ],
        },
      },
      d1: [],
      d2: [],
      t1: [],
      cnt: 0,
      max: 50,
      gotAgent: 0,
      agentLast: 0,
      customerLast: 0,
      cstCnt: 0,
      DC: null,
      services: [],
    };
  },
  created() {
    $HTTP.post("writelog", {
      demo: "Courier",
      event: "launch",
      status: "Success",
    });
    this.startup();
  },
  beforeDestroy() {
    /*         if (this.pusher) {
                    this.pusher.unsubscribe(this.flavor);
                }
         */
  },
  computed: {
    pending() {
      this.active = false;
      return this.services.filter((item) => item.status == "pending");
    },
    completed() {
      this.active = false;
      return this.services.filter((item) => item.status == "completed");
    },
    rescheduled() {
      this.active = false;
      return this.services.filter((item) => item.status == "rescheduled");
    },
  },
  methods: {
    setPlace() {
      var addressObj = {
        address_line_1: this.currentService.address,
        address_line_2: "",
        city: this.currentService.area,
        //state: 'CA', // province also valid
        //zip_code: '94043', // postal_code also valid
        //country: 'United States'
      };
      this.$geocoder.send(addressObj, (response) => {
        console.log("GEOCODER: ", response);
        this.location = response.results[0].geometry.location;
        this.mapok = true;
      });
    },
    onUpdate(payload) {
      console.log("onUpdate: ", payload);
      if (payload.isValid) {
        let phone = payload.formattedNumber.replace(/\D/g, "");
        if (phone != this.currentService.phone) {
          this.currentService.phone = phone;
          this.change();
        }
      }
    },
    onUpdate2(payload) {
      console.log("onUpdate2: ", payload);
      if (payload.isValid) {
        this.newcust.phone = payload.formattedNumber.replace(/\D/g, "");
      }
    },
    async startup(clear = null) {
      if (clear) {
        let title = this.disp("Clear Demo");
        let confirm = this.disp("Yes, Clear");
        let doexit = true;
        await this.$swal({
          title: title,
          text: title,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: confirm,
        }).then((result) => {
          if (result.value) {
            console.log("Confirm clear? ", result);
            doexit = false;
          } else {
            console.log("Do not clear...", result);
            return;
          }
        });
        if (doexit) return;
      }
      this.ringer = new Audio("/static_courier/ringing.mp3");
      var postscript = "/" + "courier";
      if ($NODEBASE.indexOf("ngrok") > 0) {
        postscript = "";
      }
      this.nodeurl = $NODEBASE + postscript;
      console.log("Got demoId: ", this.nexmo);
      if (this.nexmo.userid) {
        this.demoId = this.nexmo.userid; //this.$route.params.id;
        console.log("Passed in param id= " + this.demoId);
        this.NODEDEMO = axios.create({
          baseURL: this.nodeurl,
          headers: {
            "Content-Type": "application/json",
          },
        });
        this.NODEDEMO.interceptors.request.use((request) =>
          requestHandler(request)
        );
        let parms = {
          id: this.demoId,
          userType: this.flavor,
        };
        if (clear) {
          parms.clear = 1;
        }
        this.NODEDEMO.post("/register", parms).then(async (result) => {
          console.log(this.flavor + " registration results = ", result);
          this.nexmo.vfrom = result.data.vfrom;
          //this.nexmo["pusher_key"] = result.data.pusher_key;
          this.nexmo["userid"] = this.demoId;
          if (1 || process.env.NODE_ENV != "development") {
            this.DC = result.data.DC;
          }
          if (result.data.services) {
            console.log("Got new services");
            this.services = result.data.services;
            let time = new Date().toLocaleTimeString();
            this.services.forEach((item, index) => {
              console.log("A service...", item);
              item.changed = false;
              item.newstatus = item.status;
              item.actions = [];
              var obj = {};
              obj.timestamp = time;
              obj.type = "comment";
              obj.actionId = uuid.v1();
              obj.comment = "Starting interaction with " + item.sid;
              //item.actions.unshift(obj);
            });
            this.dest = this.services[0].address + ", " + this.services[0].area;
            this.currentService = this.services[0];
            this.currentService.avgSentiment = 0.0;
            this.currentService.numSentiment = 0;
            this.currentService.totSentiment = 0.0;
            this.currentService.avgSentimentCourier = 0.0;
            this.currentService.numSentimentCourier = 0;
            this.currentService.totSentimentCourier = 0.0;
            if (!this.currentService.phone.length) {
              console.log("No phone number");
              this.aphone = "";
              this.region = this.nexmo.region;
            } else {
              var aNumber = parsePhoneNumberFromString(
                "+" + this.currentService.phone
              );
              this.aphone = aNumber.formatNational();
              this.region = aNumber.country;
            }
            this.currentService.changed = false;
            this.currentService.newstatus = this.currentService.status;
            this.actions = this.currentService.actions;
            this.doInitiate(this.flavor);
          }
          /*                 console.log("Setting up Pusher Key: " + this.nexmo["pusher_key"]);
                                    let pusher = new Pusher(this.nexmo["pusher_key"], {
                                        //Pusher Key
                                        cluster: "us3",
                                        forceTLS: true,
                                    });
                                    this.pusher = pusher;
                                    this.channel = pusher.subscribe(this.flavor);
                     */
          this.register();
          if (
            0 &&
            (process.env.NODE_ENV === "development" ||
              !("geolocation" in navigator))
          ) {
            console.log("Geolocation is not available.");
            this.mapok = false;
          } else {
            console.log("Geolocation time!");
            // get position
            navigator.geolocation.getCurrentPosition(
              (pos) => {
                this.location = {
                  lat: pos.coords.latitude,
                  lng: pos.coords.longitude,
                };
                console.log("Got location!!! ", pos);
                this.mapok = true;
                setTimeout(() => {
                  console.log("Enabling map route");
                  this.aKey = new Date().getTime();
                }, 500);
              },
              (err) => {
                console.log(err.message);
              },
              {
                timeout: 10000,
                enableHighAccuracy: true,
              }
            );
          }
        });
      } else {
        this.demoId = this.id;
      }
    },
    change() {
      this.currentService.changed = true;
      this.buttonkey = new Date().getTime();
      console.log("Got change");
    },
    doSave(aCust) {
      let isNew = true;
      if (aCust.id) {
        if (this.currentService.status != this.currentService.newstatus) {
          this.setState(this.currentService.newstatus);
          this.currentService.status = this.currentService.newstatus;
        }
        isNew = false;
      }
      this.NODEDEMO.post("/updatecust", {
        id: this.demoId,
        dbid: aCust.id,
        name: aCust.name,
        address: aCust.address,
        area: aCust.area,
        phone: aCust.phone,
        notes: aCust.notes,
        type: aCust.type,
        status: aCust.newstatus,
      }).then(async (result) => {
        console.log("updatecust results: ", result.data);
        this.currentService.status = this.currentService.newstatus;
        this.currentService.changed = false;
      });
      this.adding = false;
      this.startup();
      this.bkey = new Date().getTime();
    },
    doDelete(aCust) {
      console.log("Deleting: ", aCust);
      if (!aCust.id) {
        return;
      }
      let title = this.disp("Delete") + " " + disp("Customer");
      let confirm = this.disp("Yes") + ", " + disp("Delete");
      this.$swal({
        title: title,
        text: title,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: confirm,
      }).then((result) => {
        if (result.value) {
          this.NODEDEMO.post("/deletecust", {
            id: this.demoId,
            dbid: aCust.id,
          }).then(async (result) => {
            console.log("deletecust results: ", result.data);
          });
          this.startup();
        }
      });
    },
    addCust() {
      console.log("Adding a new customer...");
      this.newcust = {
        name: "",
        address: "",
        area: "",
        phone: "",
        notes: "",
        type: "Delivery",
        newstatus: "pending",
        dbid: null,
      };
      this.adding = true;
    },
    doTest() {
      this.NODEDEMO.post("/getcourier", {
        id: this.demoId,
        userType: this.flavor,
      }).then(async (result) => {
        console.log("GETCOURIER results: ", result.data);
      });
    },
    getKeyByValue(object, value) {
      if (!value) return;
      return Object.keys(object).find(
        (key) => object[key].toLowerCase() === value.toLowerCase()
      );
    },
    disp(key) {
      if (!key) return "";
      if (!this.lang) return key;
      if (this.lang[key]) return this.lang[key];
      //console.dir(this.baselang);
      var phrase = this.getKeyByValue(this.baselang, key);
      //console.log("Got phrase key? "+phrase);
      if (phrase && this.lang[phrase]) {
        return this.lang[phrase];
      }
      console.log("disp missing: " + key);
      return key;
    },
    sendText() {
      if (this.currentService.conversation) {
        let message = this.newmessage;
        console.log(
          "Sending message to conversation " +
          this.currentService.conversationId +
          ": " +
          message
        );
        this.currentService.conversation
          .sendText(message)
          .then(() => {
            let time = new Date().toLocaleTimeString();
            var obj = {};
            obj.timestamp = time;
            obj.type = "note";
            obj.actionId = uuid.v1();
            obj.from = "courier";
            obj.sent = "Text";
            obj.transcript = message;
            obj.verb = "Sent";
            obj.color = "blue";
            this.actions.unshift(obj);
            this.conAdd(obj, "courier:event");
            this.aKey2 = new Date().getTime();
            this.newmessage = "";
          })
          .catch(function (err) {
            console.log("Send text error ", err);
          });
      }
    },
    stopModal() {
      this.modal = false;
      this.processing = false;
      this.recording = false;
      this.recAction = null;
      this.hangup();
    },
    showTranscript(action) {
      console.dir(this.transcripts[action.actionId]);
      this.curTrans = this.transcripts[action.actionId];
      this.okText = "Close";
      this.inCall = true;
      scrollToBottom();
    },
    startModal2(obj) {
      if (obj.type && obj.type == "image") {
        // Gotta pick up the image from media server
        if (obj.full) {
          this.bigPic = obj.full;
          this.modalImage = true;
          return;
        }
        console.log("Getting full image: " + obj.url);
        axios
          .request({
            url: obj.url,
            responseType: "arraybuffer",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.currentService.jwt,
            },
          })
          .then((result) => {
            // result.data has the binary
            console.log("Got image for " + obj.url);
            let img =
              "data:image/*;base64," +
              btoa(
                new Uint8Array(result.data).reduce(
                  (data, byte) => data + String.fromCharCode(byte),
                  ""
                )
              );
            obj.full = img;
            this.bigPic = obj.full;
            this.modalImage = true;
          });
      }
    },
    stopModal2() {
      this.modalImage = false;
    },
    conAdd(obj, type) {
      if (this.currentService.conversation) {
        this.currentService.conversation
          .sendCustomEvent({
            type: type,
            body: obj,
          })
          .then((custom_event) => {
            console.log("Sent custom event: ", custom_event);
          });
      }
    },
    pushEvent(obj) {
      console.log("Pushing action onto stack: ", obj);
      let verbs = ["Sent", "Received"];
      if (obj.type && obj.type == "statechange") {
        this.currentService.status = obj.verb;
        this.currentService.newstatus = obj.verb;
      }
      if (obj.sentiment) {
        this.setIcons(obj);
      }
      if (obj.type && obj.type == "textSentiment") {
        var sent = this.actions.find((o) => o.actionId == obj.actionId);
        if (sent) {
          sent.sentiment = obj.sentiment;
          console.log("Updating text action with Sentiment: ");
          console.dir(sent);
          this.setIcons(sent);
        }
        return;
      }
      if (
        obj.type &&
        obj.type == "call" &&
        obj.verb &&
        obj.verb == "Disconnected"
      ) {
        if (obj.from && obj.from.includes("customer")) {
          return;
        }
      }
      if (obj.from && obj.from.includes("courier")) {
        if (verbs.includes(obj.verb)) {
          obj.verb = "Sent";
        }
        obj.color = "blue";
      } else {
        if (verbs.includes(obj.verb)) {
          obj.verb = "Received";
        }
        obj.color = "green";
      }
      if (obj.type && obj.type == "image") {
        // Gotta pick up the image from media server
        console.log("Getting image: " + obj.thumb);
        axios
          .request({
            url: obj.thumb,
            responseType: "arraybuffer",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.currentService.jwt,
            },
          })
          .then((result) => {
            // result.data has the binary
            console.log("Got image for " + obj.thumb);
            let img =
              "data:image/*;base64," +
              btoa(
                new Uint8Array(result.data).reduce(
                  (data, byte) => data + String.fromCharCode(byte),
                  ""
                )
              );
            obj.image = img;
            this.aKey3 = new Date().getTime();
          });
      }
      this.actions.unshift(obj);
    },
    getTranscription(conId, cursor = null) {
      console.log("getTranscription for " + conId + " with cursor: " + cursor);
      if (!this.currentService.conversation) return;
      let options = {
        page_size: 100,
        filter: "transcription",
        //order: "desc"
      };
      if (cursor) {
        options.cursor = cursor;
      }
      this.currentService.conversation
        .getEvents(options)
        .then((events_page) => {
          console.log("Got actions from transcription for " + conId);
          console.dir(events_page);
          events_page.items.forEach((event) => {
            //console.log("Is this a transcription event? ", event);
            if (event.type == "transcription") {
              //console.log("Transcription: ", event.body);
              if (event.body.aid) {
                if (!this.transcripts[event.body.aid]) {
                  console.log("Creating array for " + event.body.aid);
                  this.transcripts[event.body.aid] = [];
                }
                event.body.timestamp = new Date(
                  event.timestamp
                ).toLocaleTimeString([], {
                  hourCycle: "h24",
                });
                if (event.body.sentiment) {
                  this.setIcons(event.body);
                }
                this.transcripts[event.body.aid].push(event.body);
              }
            }
          });
          if (events_page.cursor.next && events_page.cursor.next.length > 10) {
            this.getTranscription(conId, events_page.cursor.next);
          }
          //console.log("transcription now = ", this.transcription)
        });
    },
    setIcons(body) {
      console.log("setIcons body: ", body);
      let sentiment = 0.0;
      if (body.sentiment.SentimentScore) {
        console.log("Floaty stuff: ", body);
        if (
          (body.from && body.from.includes("customer")) ||
          (body.entity && body.entity == "customer")
        ) {
          this.currentService.numSentiment++;
          this.currentService.totSentiment +=
            parseFloat(body.sentiment.SentimentScore.Positive) -
            parseFloat(body.sentiment.SentimentScore.Negative);
          this.currentService.avgSentiment = parseFloat(
            this.currentService.totSentiment /
            parseFloat(this.currentService.numSentiment)
          );
          console.log("Floaty stuff Cust: " + this.currentService.avgSentiment);
        } else {
          this.currentService.numSentimentCourier++;
          this.currentService.totSentimentCourier +=
            parseFloat(body.sentiment.SentimentScore.Positive) -
            parseFloat(body.sentiment.SentimentScore.Negative);
          this.currentService.avgSentimentCourier = parseFloat(
            this.currentService.totSentimentCourier /
            parseFloat(this.currentService.numSentimentCourier)
          );
          console.log(
            "Floaty stuff Courier: " + this.currentService.avgSentimentCourier
          );
        }
        this.speedkey = new Date().getTime();
      }
      body.icon = "puzzled-full";
      body.iconcolor = "yellow";
      if (body.sentiment.Sentiment) {
        if (body.sentiment.Sentiment == "POSITIVE") {
          body.icon = "happy-full";
          body.iconcolor = "green";
        }
        if (body.sentiment.Sentiment == "NEGATIVE") {
          body.icon = "unhappy-full";
          body.iconcolor = "red";
        }
      } else {
        if (body.sentiment.includes("POSITIVE")) {
          body.icon = "happy-full";
          body.iconcolor = "green";
        }
        if (body.sentiment.includes("NEGATIVE")) {
          body.icon = "unhappy-full";
          body.iconcolor = "red";
        }
      }
      this.iconChange = new Date().getTime();
    },
    getActions(conId, filter, cursor = null) {
      console.log("getActions " + conId);
      if (!this.currentService.conversation) return;
      let options = {
        page_size: 100,
        //order: "desc"
      };
      if (filter) {
        options.filter = filter;
      }
      if (cursor) {
        options.cursor = cursor;
      } else {
        this.actions = [];
      }
      this.currentService.conversation
        .getEvents(options)
        .then((events_page) => {
          console.log("Got actions from conversation for " + filter);
          events_page.items.forEach((event) => {
            console.log("Got action: ", event);
            if (event.body && event.body.actionId) {
              this.pushEvent(event.body);
            }
          });
          console.log("Actions now = ", this.actions);
          if (events_page.cursor.next && events_page.cursor.next.length > 10) {
            this.getActions(conId, filter, events_page.cursor.next);
          }
        });
    },
    getConversation(conId, filter, cursor = null) {
      console.log("getConversation " + conId);
      if (!this.currentService.conversation) return;
      let options = {
        page_size: 100,
        order: "desc",
      };
      if (filter && filter.length > 1) {
        options.filter = filter;
      }
      if (cursor) {
        options.cursor = cursor;
      } else {
        this.events = [];
      }

      this.currentService.conversation
        .getEvents(options)
        .then((events_page) => {
          events_page.items.forEach((event) => {
            //console.log("Event: ", event);
            let myDate = new Date(event.timestamp).toLocaleString([], {
              hourCycle: "h24",
            });
            this.events.push({
              type: event.type,
              body: event.body,
              timestamp: myDate,
              from: event.from,
              id: event.id,
            });
          });
          if (events_page.cursor.next && events_page.cursor.next.length > 10) {
            this.getConversation(conId, filter, events_page.cursor.next);
          }
          this.showThisConvo = true;
        });
    },
    filesChange(fileList) {
      console.log("Fieldname: ", fileList);
      if (this.currentService.conversation) {
        this.currentService.conversation
          .sendImage(fileList.target.files[0])
          .then((imageRequest) => {
            imageRequest.onloadend = (e) => {
              let resp = JSON.parse(e.target.response);
              console.log("Image: ", resp);
              console.log("Id: ", resp.id);
              console.log("Thumbnail: ", resp.thumbnail.url);
              this.getFile(resp.thumbnail.url, resp.original.url);
            };
          })
          .catch(function (err) {
            console.log("Send image error ", err);
          });
      }
      this.stopModal2();
      // handle file changes
    },
    getFile(thumb, full) {
      axios
        .request({
          url: thumb,
          responseType: "arraybuffer",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.currentService.jwt,
          },
        })
        .then((result) => {
          // result.data has the binary
          let img =
            "data:image/*;base64," +
            btoa(
              new Uint8Array(result.data).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            );
          console.log("Inserting file into actions.");
          //this.rawFile(result.data);
          console.log("Ok, sent...?");
          let time = new Date().toLocaleTimeString();
          var obj = {};
          obj.timestamp = time;
          obj.type = "image";
          obj.url = full;
          obj.thumb = thumb;
          obj.actionId = uuid.v1();
          obj.from = "courier";
          obj.color = "blue";
          obj.verb = "Sent";
          this.conAdd(obj, "courier:event");
          obj.image = img;
          this.actions.unshift(obj);
          this.testimage = img;
        });
    },
    takepic() {
      this.$refs.testimg.click();
    },
    getCamera(fileList) {
      console.dir(fileList);
      this.currentService.conversation
        .sendImage(fileList.target.files[0])
        .then((imageRequest) => {
          imageRequest.onloadend = (e) => {
            let resp = JSON.parse(e.target.response);
            console.log("rawImage: ", resp);
          };
        })
        .catch(function (err) {
          console.log("Send image error ", err);
        });

      //this.camera = true;
    },
    openTab(type) {
      let url = "https://vids.vonage.com/vcourier/#/courier/" + this.demoId;
      if (type == "customer") {
        url =
          "https://vids.vonage.com/vcourier/#/customer/" +
          this.demoId +
          "?cust=" +
          this.currentService.sid;
      }
      window.open(url, "_blank");
      this.links = false;
    },
    sendLink(type) {
      this.NODEDEMO.post("/sendlink", {
        id: this.demoId,
        userType: type,
        sid: this.currentService.sid,
      }).then(async (result) => {
        let time = new Date().toLocaleTimeString();
        var obj = {};
        obj.timestamp = time;
        obj.type = "link";
        obj.actionId = uuid.v1();
        obj.from = "dispatcher";
        obj.to = type;
        obj.verb = "Sent";
        obj.color = "blue";
        this.actions.unshift(obj);
        this.conAdd(obj, "courier:event");
        this.aKey2 = new Date().getTime();
        this.links = false;
      });
    },
    async register() {
      /*
            let DC = null; //"https://api" + this.DC + ".nexmo.com";
            console.log("DC will be: " + DC);
            let client = this.DC ? new NexmoClient({
                nexmo_api_url: DC,
                url: "wss://ws" + this.DC + ".nexmo.com"
            }) : new NexmoClient();
            this.application = await client.createSession(this.jwt);
            this.initializeListener();
            */
    },
    playAudio(action) {
      let call = "play:" + action.uuid;
      console.log("Playing action: ", action);
      this.recording = false;
      this.playback = true;
      this.capplication.callServer(call);
    },
    doAction(action, type = "") {
      console.log("doAction for " + action.actionId + " with " + type);
      switch (type) {
        case "text":
          console.dir(action);
          if (this.currentService.conversation) {
            let message = action.transcript;
            console.log(
              "Sending message to conversation " +
              this.currentService.conversationId +
              ": " +
              message
            );
            this.currentService.conversation
              .sendText(message)
              .then(() => {
                action.sent = "Text";
                action.verb = "Sent";
                action.color = "blue";
                this.actions.unshift(action);
                this.conAdd(action, "courier:event");
                this.aKey2 = new Date().getTime();
                this.modal = false;
                this.processing = false;
                this.recAction = null;
              })
              .catch(function (err) {
                console.log("Send text error ", err);
                this.modal = false;
                this.processing = false;
              });
          }
          break;
        case "audio":
          if (this.currentService.conversation) {
            let message = action.transcript;
            console.log(
              "Sending message to conversation " +
              this.currentService.conversationId +
              ": " +
              message
            );
            this.currentService.conversation
              .sendText("audio|" + action.uuid + "|" + message)
              .then(() => {
                action.sent = "Audio";
                action.verb = "Sent";
                action.color = "blue";
                this.actions.unshift(action);
                this.conAdd(action, "courier:event");
                this.aKey2 = new Date().getTime();
                this.modal = false;
                this.processing = false;
                this.recAction = null;
              })
              .catch(function (err) {
                console.log("Send text error ", err);
                this.modal = false;
                this.processing = false;
              });
          }
          break;
        default:
      }
      //action.verb = "Sent";
      //action.color = "blue";
    },
    doCall() {
      return; // Dispatched does not call!
      if (this.application && this.currentService.conversationName) {
        var obj = {};
        obj.timestamp = new Date().toLocaleTimeString();
        obj.type = "call";
        obj.actionId = uuid.v1();
        obj.from = "courier";
        obj.verb = "Called";
        obj.color = "blue";
        let call =
          "call:" +
          this.currentService.conversationName +
          ":customer_" +
          this.currentService.sid +
          ":" +
          obj.actionId;
        this.paged = false;
        console.log("Calling: " + call);
        this.capplication.callServer(call);
        this.okText = "Hang Up";
        this.inCall = true;
        this.actions.unshift(obj);
        this.conAdd(obj, "courier:event");
        this.aKey2 = new Date().getTime();
        this.transcripts[obj.actionId] = [];
        this.curTrans = this.transcripts[obj.actionId];
      }
    },
    async reset() {
      this.reInit();
      return;
    },
    setState(state) {
      var obj = {};
      obj.timestamp = new Date().toLocaleTimeString();
      obj.type = "statechange";
      obj.actionId = uuid.v1();
      obj.from = "courier";
      obj.verb = state;
      obj.color = "blue";

      console.log("Switching to state: " + state);
      switch (state) {
        case "pending":
          this.currentService.status = state;
          this.actions.unshift(obj);
          this.conAdd(obj, "courier:event");
          break;
        case "completed":
          this.currentService.status = state;
          this.actions.unshift(obj);
          this.conAdd(obj, "courier:event");
          break;
        case "rescheduled":
          this.currentService.status = state;
          this.actions.unshift(obj);
          this.conAdd(obj, "courier:event");
          break;
        default:
      }
    },
    async reInit() {
      return;
      console.log("in reInit!");
      this.currentService.conversation = null;
      this.application = null;
      this.NODEDEMO.post("/initiate", {
        id: this.demoId,
        sid: this.currentService.sid,
        userType: this.flavor,
      }).then(async (result) => {
        console.log(this.flavor + " Reinitiate results = ", result);
        let url = "https://api" + this.DC + ".nexmo.com";
        console.log("DC will be: " + this.DC);
        let client = this.DC
          ? new NexmoClient({
            nexmo_api_url: url,
            url: "wss://ws" + this.DC + ".nexmo.com",
          })
          : new NexmoClient();
        setTimeout(async () => {
          this.application = await client.createSession(
            this.currentService.jwt
          );
          this.currentService.conversation =
            await this.application.getConversation(
              this.currentService.conversationId
            );
        }, 500);
        //this.doListens(this.currentService.conversation);
        //this.initializeListener();
      });
    },
    doInitiate(userType) {
      console.log(
        "Initiating " + userType + " for customer: " + this.currentService.sid
      );
      this.NODEDEMO.post("/initiate", {
        id: this.demoId,
        sid: this.currentService.sid,
        userType: userType,
      }).then(async (result) => {
        console.log(this.flavor + " initiate results = ", result);
        this.currentService.conversationId = result.data.conversation;
        this.currentService.conversationName = result.data.cname;
        this.currentService.userId = result.data.user;
        this.currentService.jwt = result.data.jwt;
        this.currentService.userName2 = result.data.name2;
        this.currentService.userId2 = result.data.user2;
        this.currentService.jwt2 = result.data.jwt2;
        this.currentService.userName = result.data.name;
        this.currentService.avgSentiment = 0.0;
        this.currentService.numSentiment = 0;
        this.currentService.totSentiment = 0.0;
        this.currentService.avgSentimentCourier = 0.0;
        this.currentService.numSentimentCourier = 0;
        this.currentService.totSentimentCourier = 0.0;
        this.setPlace();
        this.application = null;
        this.capplication = null;
        if (!this.application) {
          let url = "https://api" + this.DC + ".nexmo.com";
          console.log("DC will be: " + this.DC);
          let client = this.DC
            ? new NexmoClient({
              nexmo_api_url: url,
              url: "wss://ws" + this.DC + ".nexmo.com",
            })
            : new NexmoClient();
          let client2 = this.DC
            ? new NexmoClient({
              nexmo_api_url: url,
              url: "wss://ws" + this.DC + ".nexmo.com",
            })
            : new NexmoClient();

          this.application = await client.createSession(
            this.currentService.jwt
          );
          this.capplication = await client2.createSession(
            this.currentService.jwt2
          );

          this.initializeListener(this.capplication);
          //this.initializeListener(this.application);
        }
        if (!this.currentService.conversation) {
          this.currentService.conversation =
            await this.application.getConversation(
              this.currentService.conversationId
            );
          this.doListens(this.currentService.conversation);
        }
        console.dir(this.currentService.conversation);
        this.getActions(this.currentService.conversationId, "courier:event");
        this.getTranscription(this.currentService.conversationId);
        console.dir(this.transcripts);
        this.aKey2 = new Date().getTime();
        this.phonekey = this.aKey2;
      });
    },
    doListens(conversation) {
      console.log("doListens!");
      /*             conversation.on('text', (sender, event) => {
                            console.log('*** Message received', sender, event);
                            console.log("Sender and Me: " + sender.user.name + " , " + this.currentService.userName);
                            if (sender.user.name == this.currentService.userName) {
                                console.log("Never mind, it's from me!");
                            } else {

                            }
                        });
             */
      conversation.on("courier:event", (sender, event) => {
        console.log("*** Courier event received", sender, event);
        let sendName = sender.user ? sender.user.name : event.from;
        console.log(
          "Sender and Me: " + sendName + " , " + this.currentService.userName
        );
        if (sendName == this.currentService.userName) {
          console.log("Never mind, it's from me!");
        } else {
          let parts = sendName.split("_");
          if (!parts[4] || parts[4] != this.currentService.sid) {
            console.log("From wrong customer!", parts);
            return;
          }
          this.pushEvent(event.body);
          if (event.body.type == "page") {
            this.paged = true;
            this.ringer.currentTime = 0;
            this.ringer.play();
            setTimeout(() => {
              this.ringer.pause();
            }, 1000);
          }
        }
      });
      conversation.on("transcribe", (sender, event) => {
        console.log("*** Transcribe event received", sender, event);
        let sendName = event.body.from;
        console.log(
          "Sender and Me: " + sendName + " , " + this.currentService.userName
        );
        if (sendName.startsWith(this.currentService.userName)) {
          let time = new Date().toLocaleTimeString();
          console.log("It's from me!");
          var obj = event.body;
          obj.timestamp = time;
          obj.type = "note";
          obj.actionId = uuid.v1();
          obj.color = "red";
          this.recAction = obj;
          this.processing = false;
          //this.actions.unshift(obj);
        } else {
          console.log("It's NOT from me!");
        }
      });
      conversation.on("transcription", (sender, event) => {
        // Live conversation transcription
        console.log("*** Transcription event received", sender, event);
        let trans = event.body;
        trans.id = this.curTrans.length;
        trans.timestamp = new Date(event.timestamp).toLocaleTimeString([], {
          hourCycle: "h24",
        });
        if (!this.transcripts[trans.aid]) {
          this.transcripts[trans.aid] = [];
          this.curTrans = this.transcripts[trans.aid];
        }
        if (this.curTrans != this.transcripts[trans.aid])
          this.curTrans = this.transcripts[trans.aid];
        this.setIcons(trans);
        this.curTrans.push(trans);
        this.transkey = new Date().getTime();
        if (this.inCall) scrollToBottom();
      });
    },
    doNote(task) {
      console.log("doNote: " + task);
      if (task == "completed" || task == "rescheduled" || task == "pending") {
        this.currentService.status = task;
        console.log("Sys Event: " + task);
        this.sysevent = "Transaction " + task;
        this.active = false;
        return;
      }
      if (task == "record") {
        this.recAction = null;
        this.recording = true;
        this.processing = false;
        this.capplication.callServer("note:" + this.currentService.userId);
        console.log("Note recording started");
      }
      /*
                        this.NODEDEMO.post("/doNote", {
                            id: this.demoId,
                            userType: 'courier'
                        }).then(async (result) => {
                            console.log(this.flavor + " doNote results = ", result);
                        });
            */
    },
    async hangup() {
      console.log(this.currentCall);
      this.processing = true;
      if (this.currentCall) {
        try {
          console.log("Ok, hanging up now...");
          this.currentCall.hangUp();
        } catch (err) { }
        console.log("HUNGUP");
        /*                 var obj = {};
                                obj.timestamp = new Date().toLocaleTimeString();
                                obj.type = 'call';
                                obj.actionId = uuid.v1();
                                obj.from = 'courier';
                                obj.verb = "Disconnected";
                                obj.color = "blue";
                                this.actions.unshift(obj);
                                this.conAdd(obj, 'courier:event');
                                this.aKey2 = new Date().getTime();
                 */
      } else {
        console.log("NO CALL IN PROGRESS");
      }
      this.inCall = false;
    },
    initializeListener(application) {
      this.setIsReady(false);
      application.on("call:status:changed", async (call) => {
        console.log("Call status changed: ", call.status);
        const {
          STARTED,
          COMPLETED,
          BUSY,
          TIMEOUT,
          UNANSWERED,
          REJECTED,
          FAILED,
          RINGING,
          ANSWERED,
        } = call.CALL_STATUS;
        if (
          call.status === STARTED ||
          call.status === RINGING ||
          call.status === ANSWERED
        ) {
          console.log("Started call");
          this.setCurrentCall(call);
          console.dir(call);
          if (this.recording) {
            this.modal = true;
            this.recording = false;
          }
        } else if (
          call.status === COMPLETED ||
          call.status === BUSY ||
          call.status === TIMEOUT ||
          call.status === UNANSWERED ||
          call.status === REJECTED ||
          call.status === FAILED
        ) {
          if (this.inCall) {
            //if (!this.playback && !this.recording) {
            console.log("We are not in playback mode on call completion");
            var obj = {};
            obj.timestamp = new Date().toLocaleTimeString();
            obj.type = "call";
            obj.actionId = uuid.v1();
            obj.from = "courier";
            obj.verb = "Disconnected";
            obj.color = "blue";
            this.actions.unshift(obj);
            this.conAdd(obj, "courier:event");
            this.aKey2 = new Date().getTime();
          }
          this.playback = false;
          this.recording = false;
          this.inCall = false;
          //this.reInit();
          //this.modal = false;
        } else {
          console.log("Uncaptured status");
          //this.setCurrentCall(call);
        }
        //this.logEvent(call);
      });
      application.on("member:call", (member, call) => {
        console.log("Courier Incoming call: ", call);
        console.log("Courier Incoming member: ", member);
        let sendName = sender.user ? sender.user.name : sender.userName;
        if (sendName == this.currentService.userName) {
          return;
        }
        if (call.direction == "inbound") {
          console.log("INBOUND CALL");
          this.setCurrentCall(call);
        } else {
          this.setCurrentCall(call);
        }
      });
      this.setIsReady(true);
      console.log("Waiting for call");
    },
    setIsReady(param) {
      this.isReady = param;
    },
    setCurrentCall(param) {
      this.currentCall = param;
      if (param != null) {
        this.isReady = true;
        //this.modal = false;
      }
      console.log("Isready=" + this.isReady + " CurrentCall=" + param);
    },
    languageChange(newLang) {
      this.language = newLang;
      this.lang = this.language.fields;
      console.log(
        "New language: " +
        this.language.language +
        " ( " +
        this.language.dialect +
        " )"
      );
    },
    baseLang(base) {
      console.log("Setting baselang: ", base);
      this.baselang = base;
    },
    doService(id) {
      console.log("Looking for id: " + id);
      var service = this.services.find((o) => o.sid == id);
      this.currentService = service;
      if (!this.currentService.phone.length) {
        console.log("No phone number");
        this.aphone = "";
        this.region = this.nexmo.region;
      } else {
        var aNumber = parsePhoneNumberFromString(
          "+" + this.currentService.phone
        );
        this.aphone = aNumber.formatNational();
        this.region = aNumber.country;
      }
      this.actions = this.currentService.actions;
      this.dest = service.address + ", " + service.area;
      console.log("doService: ", service);
      this.changed = false;
      this.doInitiate(this.flavor);
    },
  },
  beforeMount() {
    console.log("BeforeMount: ", this.nexmo);
    loadGmapApi({
      key: this.nexmo.gmaps,
      libraries: "places",
    });
    this.$geocoder.setGoogleMapsApiKey(this.nexmo.gmaps);
  },
};
</script>

<style scoped>
.button1 {
  /*width: 120px;*/
  text-align: center;
  margin-left: 8px;
  display: inline-block;
}

.button2 {
  width: 240px;
  text-align: center;
  margin-left: 8px;
}

.button3 {
  padding-top: 5px;
}

.Vlt-card {
  height: 100%;
  border-bottom-right-radius: 18px;
}

.Vlt-gradient--pink-to-peach {
  border-radius: 18px;
  height: calc(100% - 24px);
  padding-right: 6px;
  padding-bottom: 6px;
}

.odd {
  background: #eee;
}

.clickable {
  cursor: pointer;
}

.dropbox {
  outline: 2px dashed grey;
  /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px;
  /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0;
  /* invisible but it's there! */
  width: 500px;
  height: 100%;
  left: 3px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue;
  /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>
